import React from "react";

export default () => <svg width="26" height="29" viewBox="0 0 26 29" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 27.9688C13.5125 27.9688 14.75 26.7313 14.75 25.2188H9.25C9.25 26.7313 10.4737 27.9688 12 27.9688Z" stroke="#A0A2A7" strokeWidth="2"/>
  <path d="M20.25 21.0938V14.2188C20.25 9.9975 17.995 6.46375 14.0625 5.52875V4.59375C14.0625 3.4525 13.1412 2.53125 12 2.53125C10.8588 2.53125 9.9375 3.4525 9.9375 4.59375V5.52875C5.99125 6.46375 3.75 9.98375 3.75 14.2188V21.0938L1 23.8438V25.2188H23V23.8438L20.25 21.0938Z" stroke="#A0A2A7" strokeWidth="2"/>
  <circle cx="21" cy="5" r="4" fill="#33ABFB" stroke="#D9D9D9" strokeWidth="2"/>
</svg>
